package nl.volleyplanner.web.base.component

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.stateIn
import kotlinx.html.TagConsumer
import kotlinx.html.div
import nl.volleyplanner.web.CoroutineManager.RENDER_SCOPE
import nl.volleyplanner.web.base.HTMLComponent
import org.w3c.dom.HTMLElement

class ListeningComponent(
    val name: String,
    val stateFlows: List<StateFlow<*>>,
    val onContentReplacedFunction: ((HTMLElement) -> Unit)? = null,
    val coroutineScope: CoroutineScope = RENDER_SCOPE,
    val block: TagConsumer<HTMLElement>.() -> HTMLElement
) : HTMLComponent() {
    override fun onContentReplaced(htmlElement: HTMLElement) {
        super.onContentReplaced(htmlElement)
        onContentReplacedFunction?.invoke(htmlElement)
    }

    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        try {
            return block.invoke(consumer)
        } catch (e: Exception) {
            println("[${this::class}@$componentId] Error rendering component $name: ${e.message}")
            e.printStackTrace()
            return consumer.div { +"Error" }
        }
    }

    override suspend fun getState() = combine(stateFlows) { it.toList() }.stateIn(coroutineScope, SharingStarted.Eagerly, emptyList())
}